import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environment';
import { FileAnswer } from '../models/Answer.model';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

   readonly #http = inject(HttpClient);

  readonly #baseUrl = `${environment.apiUrl}/answers`;

  uploadFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.#http.post<FileAnswer>(
      `${this.#baseUrl}/uploadFile`,
      formData,
    );
  }
}
